// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__338hN","index":"styles_index__3ycdC"};